var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vx-card", { staticClass: "mb-4" }, [
        _c("h4", { staticClass: "mb-1" }, [
          _vm._v(_vm._s(_vm.$t("influencer.approvals"))),
        ]),
        _c("small", { staticClass: "text-muted d-block mb-3" }, [
          _vm._v(_vm._s(_vm.$t("influencer.approvals_hint"))),
        ]),
        _vm.isLoading
          ? _c("div", { staticClass: "text-center py-4" }, [
              _c("span", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.$t("loading"))),
              ]),
            ])
          : !_vm.pending.length
          ? _c(
              "div",
              { staticClass: "text-center py-4" },
              [
                _c("feather-icon", {
                  staticClass: "h-8 w-8 text-success mb-1",
                  attrs: { icon: "CheckCircleIcon" },
                }),
                _c("p", { staticClass: "text-muted mb-0" }, [
                  _vm._v(_vm._s(_vm.$t("influencer.approvals_empty"))),
                ]),
              ],
              1
            )
          : _c(
              "div",
              _vm._l(_vm.pending, function (item) {
                return _c(
                  "div",
                  { key: item.id, staticClass: "approval-row" },
                  [
                    _c("div", { staticClass: "approval-main" }, [
                      _c("div", { staticClass: "font-medium" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                      _c("small", { staticClass: "text-muted d-block" }, [
                        _vm._v(_vm._s(item.email)),
                      ]),
                      _c(
                        "div",
                        { staticClass: "mt-1" },
                        _vm._l(item.social_profiles || [], function (p) {
                          return _c(
                            "vs-chip",
                            {
                              key: p.id,
                              staticClass: "mr-1",
                              attrs: { transparent: "", color: "primary" },
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: p.profile_url,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(p.network_label) +
                                      " @" +
                                      _vm._s(p.handle) +
                                      " "
                                  ),
                                ]
                              ),
                              p.followers
                                ? _c("span", [
                                    _vm._v(
                                      " · " +
                                        _vm._s(_vm.formatFollowers(p.followers))
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        }),
                        1
                      ),
                      item.bio
                        ? _c(
                            "p",
                            { staticClass: "mt-1 mb-0 text-muted small" },
                            [_vm._v(_vm._s(item.bio))]
                          )
                        : _vm._e(),
                      _c("small", { staticClass: "text-muted d-block mt-1" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("influencer.source")) +
                            ": " +
                            _vm._s(
                              _vm.$t("influencer.source_." + item.source)
                            ) +
                            " · " +
                            _vm._s(_vm.$t("influencer.applied_at")) +
                            ": " +
                            _vm._s(_vm.formatDate(item.created_at)) +
                            " "
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "approval-actions" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              size: "sm",
                              variant: "success",
                              disabled: _vm.busyId === item.id,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.approve(item)
                              },
                            },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-25",
                              attrs: { icon: "CheckIcon" },
                            }),
                            _vm._v(_vm._s(_vm.$t("influencer.approve")) + " "),
                          ],
                          1
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              size: "sm",
                              variant: "outline-danger",
                              disabled: _vm.busyId === item.id,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openReject(item)
                              },
                            },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-25",
                              attrs: { icon: "XIcon" },
                            }),
                            _vm._v(_vm._s(_vm.$t("influencer.reject")) + " "),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.$t("influencer.reject"),
            "ok-title": _vm.$t("influencer.reject"),
            "cancel-title": _vm.$t("cancel"),
            "ok-variant": "danger",
          },
          on: { ok: _vm.confirmReject },
          model: {
            value: _vm.rejectModal,
            callback: function ($$v) {
              _vm.rejectModal = $$v
            },
            expression: "rejectModal",
          },
        },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                label: _vm.$t("influencer.reject_reason"),
                "label-for": "reject_reason",
              },
            },
            [
              _c("b-form-textarea", {
                attrs: { id: "reject_reason", rows: "3" },
                model: {
                  value: _vm.rejectReason,
                  callback: function ($$v) {
                    _vm.rejectReason = $$v
                  },
                  expression: "rejectReason",
                },
              }),
              _c("small", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.$t("influencer.reject_reason_hint"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }